import { render } from "./Accordian.vue?vue&type=template&id=9bff64ac&ts=true"
import script from "./Accordian.vue?vue&type=script&lang=ts"
export * from "./Accordian.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__